import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button, useAppLayoutContextConsumer, AddIcon, Page } from '@occc-app/design-system';
import { getListPageLinks } from '@occc-app/routes/ProgramManagement/utils';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { GameTableContainer } from './GameTableContainer';

import { messages } from '../messages';
import { programManagementGameRouteCreator } from '../utils';

export const GameListPage = () => {
  // useMemo is used here to avoid maximum update depth exceeded.
  const links = useMemo(() => getListPageLinks(OfferType.VoucheredGame), []);
  useAppLayoutContextConsumer(links);

  const isUserPermittedToCreateGame = useIsUserPermittedTo(Feature.GAME_CREATE);

  return (
    <Page
      browserTabTitle={messages.listPageTitle}
      pageHeaderProps={{
        title: messages.listPageTitle,
      }}
      actions={
        isUserPermittedToCreateGame ? (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to={programManagementGameRouteCreator.create()}
            startIcon={<AddIcon />}
            role='button'
          >
            Create Game
          </Button>
        ) : null
      }
    >
      <GameTableContainer />
    </Page>
  );
};
